export const CollapseTextProps = (isDesk: boolean) => {
  if (isDesk) {
    return { fontSize: 16, maxTextLength: 351, defaultTextHeight: 68 };
  }
  return { fontSize: 14, maxTextLength: 159, defaultTextHeight: 57 };
};

export default CollapseTextProps;
